/**
 * The graceful fallback shown when the top-level Sentry.ErrorBoundary catches an unhandled
 * render error (D-hardening-sentry). Kept in its own file so main.tsx stays a thin entry
 * point. Deliberately plain (no MUI, no data): it must render even when the app tree is the
 * thing that failed.
 */
export const AppError = () => (
  <div
    style={{
      maxWidth: 520,
      margin: '3rem auto',
      padding: '1.5rem',
      fontFamily: 'system-ui, sans-serif',
    }}
  >
    <h1 style={{ fontSize: '1.25rem', marginBottom: '0.5rem' }}>
      Something went wrong
    </h1>
    <p style={{ color: '#555', lineHeight: 1.5 }}>
      Try reloading the page. If it keeps happening, contact an administrator.
    </p>
  </div>
);
